import { fetchJson } from '../../GlobalStateContainer'

import {
  SELECT_SHIPPING_METHOD,
  SELECTING_SHIPPING_METHOD_ASYNC,
  SHIPPING_METHODS_ARE_VALID,
  SHIPPING_METHODS_UPDATED
} from '../../GlobalStateContainer'

import { notifyError } from '../UserMessaging'

export function selectShippingMethod(shippingMethodId) {
  return { type: SELECT_SHIPPING_METHOD, shippingMethodId }
}

export function shippingMethodsAreValid(isValid) {
  return { type: SHIPPING_METHODS_ARE_VALID, isValid }
}

export function updateShippingMethods(methods) {
  return {type: SHIPPING_METHODS_UPDATED, methods }
}

let openShippingMethodRequests = 0;

const notifyWillUpdateShippingMethods = function() {
  ++openShippingMethodRequests;
  return shippingMethodsAreValid(false); 
}

const onSuccessUpdateShippingMethods = function(json) {
  --openShippingMethodRequests;
  if (openShippingMethodRequests === 0) {
    return [updateShippingMethods(json), shippingMethodsAreValid(true)];
  } else {
    return updateShippingMethods(json);
  }
}
const asyncFailedTroubleshootOrContactMessage = "Please reload the page to try again or contact customer service";

const onErrorUpdateShippingMethods = function(diagMsg) {
  --openShippingMethodRequests;
  if (openShippingMethodRequests === 0) {
    return [
      shippingMethodsAreValid(true),
      notifyError(
        "Retrieving shipping methods failed. The shipping quote may not be accurate. " + asyncFailedTroubleshootOrContactMessage, diagMsg)
    ];
  }
  return notifyError("An error occurred retrieving shipping methods", diagMsg); 
}

const updateShippingMethodsFetchSpec = {
  endpoint : state =>   state.constants.navigation.getShippingMethodsEndpoint ,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify   : notifyWillUpdateShippingMethods,
  extract  : response => response.json(),
  onSuccess: onSuccessUpdateShippingMethods,
  onError  : onErrorUpdateShippingMethods
};

export const updateShippingMethodsAsync = fetchJson(updateShippingMethodsFetchSpec);

const selectShippingMethodFetchSpec = {
  endpoint : state =>   state.constants.navigation.setShippingMethodEndpoint,
  fetchInit: { method: 'POST', credentials: 'same-origin' },
  notify   : () => ({ type: SELECTING_SHIPPING_METHOD_ASYNC }),
  extract  : response => response.json(),
  onSuccess: json => selectShippingMethod(json.shippingMethodId) ,
  onError  : diagMsg => notifyError("Selecting your shipping method failed. "+ asyncFailedTroubleshootOrContactMessage, diagMsg)
};

export const selectShippingMethodAsync = fetchJson(selectShippingMethodFetchSpec);


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/ShippingMethod/shippingMethodActions.js